module.exports = __webpack_public_path__ + "static/media/pig-blue.3983a31f.webp";